import { IMapRepository, MapEntity, ResponseValueObject } from '@gishub/domain';
import { BasemapRepository } from './basemap-repository';

export class MapRepository implements IMapRepository {
  static readonly #STORAGE_KEY = 'ghp_map';

  async load(): Promise<ResponseValueObject<MapEntity>> {
    try {
      const raw = localStorage.getItem(MapRepository.#STORAGE_KEY);
      if (!raw) return await this.#defaults();
      const p = JSON.parse(raw) as Partial<MapEntity>;
      const def = (await this.#defaults()).data!;
      return new ResponseValueObject(true, {
        ...def,
        center: Array.isArray(p.center) && p.center.length === 2
          ? [p.center[0], p.center[1]]
          : def.center,
        zoom: typeof p.zoom === 'number' ? p.zoom : def.zoom,
        rotation: typeof p.rotation === 'number' ? p.rotation : def.rotation,
      });
    } catch {
      return await this.#defaults();
    }
  }

  async #defaults(): Promise<ResponseValueObject<MapEntity>> {
    const repo = new BasemapRepository();
    const basemapResult = await repo.getDefault();
    if (!basemapResult.success || !basemapResult.data) {
      throw new Error('No default basemap available');
    }
    const b = basemapResult.data;
    return new ResponseValueObject(true, {
      center: [-75.02, -11.5],
      zoom: 7,
      rotation: 0,
      basemap: {
        urlTemplate: b.urlTemplate,
        copyright: b.attribution,
        id: b.id,
        title: b.name,
        subDomains: [...b.subDomains],
      },
      elevation: {
        url: 'https://elevation3d.arcgis.com/arcgis/rest/services/WorldElevation3D/Terrain3D/ImageServer',
      },
      scene: {
        qualityProfile: 'high',
        atmosphereQuality: 'high',
        starsEnabled: true,
        lighting: {
          directShadowsEnabled: true,
          ambientOcclusionEnabled: true,
          date: '2024-03-15T20:00:00.000Z',
        },
      },
    });
  }

  async save(entity: MapEntity): Promise<ResponseValueObject<void>> {
    try {
      localStorage.setItem(MapRepository.#STORAGE_KEY, JSON.stringify({
        center: entity.center,
        zoom: entity.zoom,
        rotation: entity.rotation,
      }));
      return new ResponseValueObject(true, undefined);
    } catch {
      return new ResponseValueObject(true, undefined);
    }
  }
}
